import {useEffect, useState} from "react";
import {collection, getFirestore, onSnapshot, query} from "firebase/firestore";
import {BiSearch} from "react-icons/bi";
import { Table } from "react-bootstrap";
import CelebPromos from "./celebPromos";
import CelebrityTabCelebrityRow from "../celebs/components/celebrityRow";

export default function Promos(){

    const [celebs,setCelebs]= useState([]);
    const [celebIds,setCelebIds]= useState([]);
    const [search,setSearch]= useState("");
    const [seeDetails,setSeeDetails]= useState(false);
    const [currentCelebDetailsId,setCurrentCelebDetailsId]=useState("");
    const db=getFirestore();



    const handleSearchChange=(e)=>{
        setSearch(e.target.value.trim());
        console.log(e.target.value);
    }



    useEffect(
        async()=>{
            const q = query(collection(db, "celebrities"));
            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const tempList = [];
                const tempIdList = [];

                querySnapshot.forEach((doc) => {
                    let data=doc.data();

                    if
                    (
                        data["fullName"].toString().toLowerCase().includes(search.trim().toLowerCase()) ||
                        data["email"].toString().toLowerCase().includes(search.trim().toLowerCase()) ||
                        data["phone"].toString().toLowerCase().includes(search.trim().toLowerCase()) ||
                        doc.id.toString().toLowerCase().includes(search.trim().toLowerCase())

                        )
                    {
                        tempList.push(doc.data());
                        tempIdList.push(doc.id);
                    }
                    else
                    {

                    }

                });

                setCelebs([...tempList])
                setCelebIds([...tempIdList]);
                
              
            });

            return function(){
                unsubscribe();
            };
        },
        [search,seeDetails]
    );


    const handleSeeCelebDetails=(celebIndex)=>{
        console.log(celebIndex);
        setCurrentCelebDetailsId(celebIds[celebIndex]);
        setSeeDetails(true);
    }

    const closeDialog=()=>{
        setSeeDetails(false);
        console.log('closed');
    }


    return(
        <div className="relative bg-transparent w-full h-full">
            {seeDetails===true?<CelebPromos closeButton={()=>closeDialog()} id={currentCelebDetailsId} />:<div className="z-10 absolute"/>}

            <div className="absolute h-full w-full p-10 flex justify-start items-start flex-col">
            <div className="text-white font-bold rounded-sm text-3xl mb-5">Promos</div>

            <div className="flex flex-row w-2/4 bg-white mb-10 ">
                <input
                    onChange={(e)=>{handleSearchChange(e)}}
                    placeholder="Search"
                    className="w-11/12 p-3 text-black bg-white border-0 outline-0 shadow-xl"/>

                <div className="w-1/12 flex justify-center items-center">
                    <BiSearch size={40} color={"black"}/>
                </div>
            </div>

            <div className="w-full">
                <Table striped bordered hover className="text-white table-fixed">

                    <thead>
                        <tr className="w-full">
                            <th>
                                <div className="flex justify-center">
                                    Image
                                </div>
                            </th>
                            <th>
                                <div className="flex justify-center">
                                    Name
                                </div>
                            </th>
                            <th>
                                <div className="flex justify-center">
                                    Contact
                                </div>
                            </th>
                            <th>
                                <div className="flex justify-center">
                                    Country
                                </div>
                            </th>
                            <th>
                                <div className="flex justify-center">
                                    Date of Birth
                                </div>
                            </th>
                        
                            <th>
                                <div className="flex justify-center">
                                    Copy Id
                                </div>
                            </th>
                            <th>
                                <div className="flex justify-center">
                                    View Details
                                </div>
                            </th>
                        </tr>
                    </thead>



                    <tbody>
                    {
                        celebs.map(
                            (celebData,celebIndex)=>{
                                return(
                                    <CelebrityTabCelebrityRow
                                    seeUserInfo={()=>{handleSeeCelebDetails(celebIndex);}}
                                    key={celebIndex}
                                    id={celebIds[celebIndex]}
                                    celebData={celebData} />
                                )
                            }
                        )
                    }
                    </tbody>


                </Table>
            </div>

            

            </div> 
                
        </div>
    )
}